<div [pTooltip]="label" tooltipStyleClass="tooltip" [tooltipPosition]="position" [tooltipEvent]="event">
  <ng-content></ng-content>
</div>